import React from 'react';
import './Section.css';

interface SectionProps {
  title: string;
  content: string | React.ReactNode;
  bgColor: string;
  imageUrl?: string;
  imagePosition?: 'left' | 'right';
  children?: React.ReactNode;
  type?: 'image' | 'pdf' | 'contact' | 'default';
}

const Section: React.FC<SectionProps> = ({
  title,
  content,
  bgColor,
  imageUrl,
  imagePosition = 'left',
  children,
  type = 'default'
}) => {
  const renderMedia = () => {
    switch (type) {
      case 'image':
        return (
          <div className="image-container">
            <img src={imageUrl} alt={title} />
          </div>
        );
      case 'pdf':
        // Avoid double-wrapping if the caller already provided a pdf-container element
        if (React.isValidElement(children)) {
          const childClass = (children as React.ReactElement<{ className?: string }>).props.className;
          if (typeof childClass === 'string' && childClass.includes('pdf-container')) {
            return children as React.ReactElement;
          }
        }

        return (
          <div className="pdf-container">
            {children}
          </div>
        );
      case 'contact':
        return (
          <div className="contact-form-container">
            {children}
          </div>
        );
      default:
        return null;
    }
  };

    const sectionStyle = {
      backgroundColor: bgColor,
      ...(imageUrl ? { '--section-bg-image': `url(${imageUrl})` } as React.CSSProperties : {})
    };

  return (
    <section className="section" style={sectionStyle} data-has-image={!!imageUrl} data-type={type}>
      <div className={`section-content ${imagePosition}`}>
        <div className="text-content">
          <div className="text-box">
            <h2>{title}</h2>
            {typeof content === 'string' ? <p>{content}</p> : content}
            {type === 'default' && children}
          </div>
        </div>
        {renderMedia()}
      </div>
    </section>
  );
};

export default Section;